//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BusinessProcessMessageText from './BusinessProcessMessageText.vue'

export default {
  components: {
    BusinessProcessMessageText
  },
  props: {
    messages: {
      type: Array,
      default: null
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    messagesLocal: function () {
      return this.messages || []
    }
  }
}

